/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var isMobile = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) ? true : false;
  
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        var $header = $('#header'),
            $preHeader = $('.mutations_brand'),
            headerFixed = 0,
            windowWidth = $(window).width(),
            windowHeight = $(window).height(),
            headerScrollTop = (windowWidth < 992) ? 15 : 50;

        $(window).scroll(function() {
          var sct = $(this).scrollTop();

          if (sct >= headerScrollTop && !headerFixed) {
            $header.addClass('onscroll');
            $preHeader.addClass('onscroll');
            headerFixed = 1;
          } else if (sct < headerScrollTop && headerFixed) {
            $header.removeClass('onscroll');
            $preHeader.removeClass('onscroll');
            headerFixed = 0;
          }
        });
        
        $('select.form-control').customSelect({
          customClass: 'form-control',
          width: '100%'
        }); 

        $('select.form-control-m').customSelect({
          customClass: 'form-control-m',
          width: '100%'
        });  

        $('select.s-inscription-invites-select').customSelect({
          customClass: 's-inscription-invites-select',
          width: '100%'
        });

        var invitesNr = 0;

        $('.s-inscription-invites-add').on('click', function(e) {
          e.preventDefault();

          invitesNr++;

          var $li = $(this).closest('.list-group-item');

          $li.find('input').each(function() {
            $(this).attr('value', $(this).val());
          });

          var content = $li.html(),
              $newLi = $('<li>').attr({
                class: 'list-group-item'
              }).html(content).hide().insertBefore($li);

            $newLi.find('.s-inscription-invites-add .icon').attr('class', 'icon icon-minus');
            $newLi.find('.number').text(invitesNr);
            $li.find('.number').text(invitesNr+1);

            $newLi.find('select').siblings('span').remove();
            $newLi.find('select').attr('style', '').removeClass('hasCustomSelect');
            
            $newLi.find('[data-name]').each(function() {
              $(this).attr('name', $(this).attr('data-name').replace('%n', invitesNr));
            });

            setTimeout(function() {
              $newLi.find('select').customSelect({
                customClass: 's-inscription-invites-select'
              });
            }, 0);

            $newLi.fadeIn(300);

            $li.find('input').val('');

            function formatLi($li, nr) {
              $li.find('.number').text(nr);
              $li.find('[data-name]').each(function() {
                $(this).attr('name', $(this).attr('data-name').replace('%n', nr));
              });
            }

            $newLi.find('.s-inscription-invites-add').on('click', function(e) {
              e.preventDefault();

              var filledInputs = $newLi.find('input').filter(function () {
                                  return !!this.value;
                              }).length;

              if (!filledInputs || confirm("Vous êtes sûre?")) {
                  invitesNr--;

                  var nr = parseInt($newLi.find('.number').text());
                  var $nextLi = $newLi.next();
                  while ($nextLi.length) {
                    formatLi($nextLi, nr);
                    nr++;
                    $nextLi = $nextLi.next();
                  }

                  $newLi.fadeOut(300, function() {
                    $newLi.remove();
                  });
              }
            });

        });

        $('.s-inscription-form .panel-heading').on('click', function(e) {
          e.preventDefault();

          var $panel = $(this).closest('.panel'),
              completed = $panel.hasClass('panel-completed') ? 1 : 0;

          if (completed) {
            $panel.find('.panel-collapse').collapse('toggle');
            $panel.siblings('.panel').not('.panel-unactive,.panel-copleted').find('.panel-collapse').collapse('toggle');
          }
        });

        $('input[name="user_type"]').change(function() {
          $(this).closest('.panel').find('.btn-inscription-next').attr('disabled', false);
        });

        $('.btn-inscription-next').on('click', function(e) {
          e.preventDefault();

          if ($(this).attr('disabled') === 'disabled') {
            return;
          }

          var $collapse = $(this).closest('.panel-collapse'),
              $nextCollapse = $collapse.closest('.panel').next().find('.panel-collapse');

          $collapse.closest('.panel').addClass('panel-completed');
          $nextCollapse.closest('.panel').removeClass('panel-unactive');

          $collapse.collapse('toggle');
          $nextCollapse.collapse('toggle');
        });

        var allowSend = 0;

        $('#s-inscription-2').find('[required]').on('blur', function() {
          var $panel = $(this).closest('.panel'),
              empties = $panel.find('[required]').filter(function () {
                                  return !this.value;
                              }).length;

          if (!empties) {
            allowSend = 1;
            $panel.find('.btn-inscription-next').attr('disabled', false);
          }
        });

        $('form[name="inscription"]').submit(function(e) {
          e.preventDefault();

          if (!allowSend) {
            return;
          }

          var $form = $(this);

          $form.find('button[type="submit"]').addClass('btn-loading');

          var formData = new FormData($form[0]);
/*
          var data = $form.serializeArray(), 
              sendData = {};

          $.each(data, function(k,v) {
            sendData[v.name] = v.value;
          });
*/
          $.ajax({
            method: 'POST',
            url: wpobject.ajax_url,
            data: formData,
            cache: false,
            contentType: false,
            processData: false
          }).success(function(data) {
            if (data.status === 'OK') {
              if (data.redirect) {
                window.location.href = data.redirect;
              } else {
                window.location.reload();
              }
            } else {
              alert(data.msg);
            }
          });
        });

        var isMenuDisplayed = ($('.navbar-nav.search-open').length) ? true : false;

        $('.toggle-search').on('click', function(e) {
          e.preventDefault();

          var $nav = $(this).closest('.navbar-nav');

          if (isMenuDisplayed && $(this).hasClass('toggle-search-send')) {
            $nav.find('form').submit();
            return;
          }

          if (!$nav.hasClass('search-open')) {
            $nav.find('.input-search input[type="text"]').focus();
          } else {
            $nav.find('.input-search input[type="text"]').blur();
          }

          $nav.toggleClass('search-open');

          isMenuDisplayed = !isMenuDisplayed;
        });

        var $desktopMenu = $('.desktop-menu');

        $('.show-menu').on('click', function(e) {
          e.preventDefault();
          //$('body').toggleClass('overflow');


          var ww = $(window).width();

          if (ww < 992) {
            $('#body').toggleClass('show-mobile-menu');
            $('#header').toggleClass('show-mobile-menu');
            $('.mutations_brand ').toggleClass('show-mobile-menu');
            $('.menu_responsive').toggle();
            $('body').toggleClass('overflow');
            
            return; 
          }

          if (isMenuDisplayed) {
            $('.navbar').removeClass('show-menu');
            setTimeout(function() {
              $desktopMenu.css('display', 'none');
              $('body').removeClass('fix-scrollbar');
              $('body').removeClass('menu-open');
            }, 250);
          } else {
            var originalWW = $(window).width();
            $('body').addClass('menu-open');

            var newWW = $(window).width();
            if (newWW > originalWW) {
              $('body').addClass('fix-scrollbar');
            }

            setTimeout(function() {
              $desktopMenu.css('display', 'block');
              $('.navbar').addClass('show-menu');
            }, 0);
          }

          $(this).find('.search-open').removeClass('search-open');

          isMenuDisplayed = !isMenuDisplayed;
/*
          var width = $(window).width();
          $('.dropdown-menu').slideToggle('fast');
          if(width >=992){
            $('.icon',this).toggleClass('icon-menu icon-remove-symbol');
          }
          
          $('.desktop-menu').toggle();
          $('.st0').toggleClass('white');
          $('.st1').toggleClass('white');
          $('.not_click').toggleClass('opacity_not');
          $('.click').toggleClass('opacity_ok');

         

          if(width <= 992){
            $('.body').toggleClass('body_translate');
            $('.menu_responsive').toggle();
            $('.icon',this).toggleClass('icon-menu icon-menu');
          }
          */
        });

        var width = $(window).width();
        if (width <= 992) {
          
          $('.menu-item-has-children > a').on('click', function(e) {
            e.preventDefault();
            
            $(this).siblings('.sub-menu').toggle();
            $(this).toggleClass('hover_a');

          });
        }

        // $('.desktop-menu').find('.menus-menu > li > a').mouseenter(function(){

        //     $(this).parent().addClass('active');
        //     $(this).parent().siblings().removeClass('active');

            
        // });

        // $('.desktop-menu').find('.menus-menu').mouseleave(function(){
        //   $('.menus-menu > li').removeClass('active');

        // });  

        $('[data-toggle="popover"]').popover({
          html: true,
          animation: false,
          container: 'body',
          placement: 'top'
        });
        
        $('.s-program-carousel').owlCarousel({
          loop: false,
          nav: true,
          items: 1,
          navText: ['<i class="icon-arrow-left icon">','<i class="icon-arrow-right icon">'],
          dots: true,
          margin: 10,
          stagePadding: 30,
          responsiveClass: true,
          responsive: {
            992: {
              dots: false,
              items: 2,
              margin: 20,
              stagePadding: 90
            },
            1200: {
              items: 3,
              stagePadding: 0,
              margin: 20,
              dots: false,
              nav: false
            }
          }
        });

        var focusInput = function($input) {
          $input.closest('.form-group').addClass('form-group-active');
        },
        blurInput = function($input) {
          if ($input.val().length) {
            return;
          }

          $input.closest('.form-group').removeClass('form-group-active');
        };

        $('.wpcf7-form .form-control,.form-group.with-bmd .form-control').on('focus', function() {
          focusInput($(this));
        })
        .on('blur', function() {
          blurInput($(this));
        });

        $('.wpcf7-form').find('label').on('click', function() {
          $(this).siblings('input,textarea').focus();
        });

        $('.s-team--modal-open').on('click', function(e) {
          e.preventDefault();
          
          var id = $(this).attr('data-target');
          $(id).modal('show');
        });

        $('.modal-content').on('click', function(e) {
          return false;
        });

        $('.modal-dialog').on('click', function(e) {
          var $modal = $(this).closest('.modal');
          $modal.modal('hide');
        });

        $('.modal .close').on('click', function(e) {
          e.preventDefault();

          $(this).closest('.modal').modal('hide');
        });
     

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        var $homeSlide = $('#homeslide'),
            windowWidth = $(window).width(),
            windowHeight = $(window).height();

        var key = (isMobile) ? 'data-xs-src' : 'data-src';

        $homeSlide.find('img').each(function() {
          var src = $(this).attr(key);
          if (src) {
            $(this).attr('src', src);
          }
        });

        $(window).resize(function() {
          windowWidth = $(window).width();
          windowHeight = $(window).height();

          $homeSlide.parent().css('height', windowHeight + 'px');
        });

        $homeSlide.parent().css('height', windowHeight + 'px');
        
        var loop = $homeSlide.find('> div').length > 1 ? true : false,
            homeSlideOwl = $homeSlide.owlCarousel({
              loop: loop,
              mouseDrag: loop,
              touchDrag: loop,
              nav: false,
              items: 1,
              dots: true,
              responsiveClass: true,
              autoplay: true,
              autoplayTimeout: 8000
            });


        $('.go-to-next-section').on('click', function(e) {
          e.preventDefault();

          $('html,body').animate({
            scrollTop: windowHeight - 105
          }, 500);
        });
              
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
